import moment from "moment";

export default new class MomentCache {
	constructor() {
		this.cache = {};
	}

	moment(dateString, format = 'MM/DD/YYYY') {
		return this.cache[dateString] || (this.cache[dateString] = moment(dateString, format));
	}
};
